import { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { LoadingState, ErrorState } from '../../components/LoadingState';
import { useGenerateExpand } from '../../api/queries';
import sumStyles from '../summary/SummaryView.module.css';

export function ExpandView() {
  const mut = useGenerateExpand();
  useEffect(() => {
    if (!mut.data && !mut.isPending && !mut.error) mut.mutate({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (mut.isPending) return <LoadingState label="Ampliando el contenido…" hint="Reuniendo lecturas relacionadas" />;
  if (mut.error) return <ErrorState error={mut.error} onRetry={() => mut.mutate({})} />;
  const data = mut.data as any;
  if (!data) return null;
  const md: string =
    data.content?.markdown ??
    (typeof data.content?.expansion === 'string'
      ? data.content.expansion
      : expansionToMarkdown(data.content?.expansion));
  return (
    <article className={sumStyles.markdown}>
      <ReactMarkdown>{md}</ReactMarkdown>
    </article>
  );
}

// Backend returns `expansion` as a structured object. Flatten it into
// markdown so we can reuse the summary view's typography pipeline.
function expansionToMarkdown(exp: any): string {
  if (!exp || typeof exp !== 'object') return '';
  const out: string[] = [];

  const ctx = exp.context;
  if (ctx?.historical) out.push('## Contexto histórico', ctx.historical);
  if (ctx?.theoretical) out.push('## Marco teórico', ctx.theoretical);

  const conn = exp.connections;
  if (conn?.current_debates) out.push('## Debate actual', conn.current_debates);
  if (Array.isArray(conn?.other_fields) && conn.other_fields.length) {
    out.push('## Conexiones con otras disciplinas');
    for (const f of conn.other_fields) {
      if (f?.field || f?.connection)
        out.push(`- **${f.field ?? ''}**: ${f.connection ?? ''}`);
    }
  }

  if (exp.advanced_aspects)
    out.push('## Aspectos avanzados', exp.advanced_aspects);

  if (Array.isArray(exp.related_concepts) && exp.related_concepts.length) {
    out.push('## Conceptos relacionados');
    for (const c of exp.related_concepts) {
      if (c?.concept) out.push(`### ${c.concept}`);
      if (c?.explanation) out.push(c.explanation);
      if (c?.relevance) out.push(`*${c.relevance}*`);
    }
  }

  if (Array.isArray(exp.perspectives) && exp.perspectives.length) {
    out.push('## Perspectivas');
    for (const p of exp.perspectives) {
      if (p?.approach) out.push(`### ${p.approach}`);
      if (p?.key_points) out.push(p.key_points);
      if (p?.current_status)
        out.push(`**Estado actual:** ${p.current_status}`);
    }
  }

  return out.join('\n\n');
}
